import login from './use-cases/login.js'
import register from './use-cases/register.js'
import getUserData from './use-cases/getUserData.js'
import deleteUserData from './use-cases/deleteUserData.js'

class AuthController {
  static async getUserData(localRepo) {
    return getUserData(localRepo)
  }

  static async deleteUserData(localRepo) {
    return deleteUserData(localRepo)
  }

  static async login(data, networkRepo, localRepo) {
    return login(data, networkRepo, localRepo)
  }

  static async register(data, networkRepo, localRepo) {
    return register(data, networkRepo, localRepo)
  }
 
  static async getProfile(networkRepo) {
    return networkRepo.getProfile()
  }
}

export default AuthController
